// extracted by mini-css-extract-plugin
export var inline = "_vp-0";